import posts from "@/shared/api/posts";
import { mockArticles, mockAPIResponse } from "./mockData";

class SitemapGenerator {
    constructor() {
        this.baseUrl = 'https://cope.by';
        this.staticPages = [
            { url: '/', priority: 1.0, changefreq: 'daily' },
            { url: '/articles', priority: 0.8, changefreq: 'weekly' },
            { url: '/tests', priority: 0.8, changefreq: 'weekly' },
        ];
    }

    async generateSitemap() {
        console.log('🚀 Starting sitemap generation...');
        
        try {
            // Получаем все опубликованные статьи
            const articles = [];
            let page = 1;
            let hasMore = true;
            let maxPages = 10; // Ограничение для безопасности
            let apiAvailable = false;

            console.log('📡 Fetching articles from API...');

            while (hasMore && page <= maxPages) {
                try {
                    console.log(`📄 Fetching page ${page}...`);
                    const response = await posts.getPublishedPosts(page, 100);
                    console.log(`✅ Page ${page} response:`, response);
                    apiAvailable = true;
                    
                    if (response && response.posts && response.posts.length > 0) {
                        articles.push(...response.posts);
                        console.log(`📝 Added ${response.posts.length} articles, total: ${articles.length}`);
                        
                        // Показываем slug'и добавленных статей
                        response.posts.forEach(article => {
                            console.log(`   - ${article.slug}: ${article.title}`);
                        });
                        
                        page++;
                        
                        // Если это последняя страница
                        if (response.posts.length < 100 || (response.totalPages && page > response.totalPages)) {
                            hasMore = false;
                        }
                    } else {
                        console.log(`📭 No articles on page ${page}, stopping...`);
                        hasMore = false;
                    }
                } catch (err) {
                    console.error(`❌ Error fetching page ${page}:`, err);
                    hasMore = false;
                    
                    // Если первая страница не загрузилась, используем mock данные
                    if (page === 1) {
                        console.log('🧪 API unavailable, using mock data');
                        articles.push(...mockArticles);
                        mockArticles.forEach(article => {
                            console.log(`   - MOCK ${article.slug}: ${article.title}`);
                        });
                    }
                }
            }

            console.log(`📊 Total articles found: ${articles.length} (API available: ${apiAvailable})`);

            // Генерируем XML
            console.log('🔧 Generating XML...');
            const urls = [
                ...this.staticPages.map(page => this.formatUrl(page.url, page.priority, page.changefreq)),
                ...articles.map(article => {
                    console.log(`📄 Adding article to sitemap: ${article.slug}`);
                    return this.formatUrl(
                        `/article/${article.slug}`,
                        0.9,
                        'weekly',
                        article.updatedAt || article.createdAt
                    );
                })
            ];

            const sitemap = `<?xml version="1.0" encoding="UTF-8"?>
<urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9">
${urls.join('\n')}
</urlset>`;

            console.log(`✅ Sitemap generated with ${urls.length} URLs`);
            return sitemap;
        } catch (error) {
            console.error('💥 Critical error generating sitemap:', error);
            
            // Fallback - возвращаем статические страницы + mock статьи
            console.log('🔄 Using fallback sitemap...');
            const urls = [
                ...this.staticPages.map(page => 
                    this.formatUrl(page.url, page.priority, page.changefreq)
                ),
                ...mockArticles.map(article => this.formatUrl(
                    `/article/${article.slug}`,
                    0.9,
                    'weekly',
                    article.updatedAt || article.createdAt
                ))
            ];
            
            const fallbackSitemap = `<?xml version="1.0" encoding="UTF-8"?>
<urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9">
${urls.join('\n')}
</urlset>`;
            
            console.log(`🆘 Fallback sitemap generated with ${urls.length} URLs`);
            return fallbackSitemap;
        }
    }

    formatUrl(path, priority, changefreq, lastmod = null) {
        const url = `${this.baseUrl}${path}`;
        const lastmodStr = lastmod ? new Date(lastmod).toISOString().split('T')[0] : new Date().toISOString().split('T')[0];
        
        return `  <url>
    <loc>${url}</loc>
    <lastmod>${lastmodStr}</lastmod>
    <changefreq>${changefreq}</changefreq>
    <priority>${priority}</priority>
  </url>`;
    }

    async pingSearchEngines() {
        const sitemapUrl = `${this.baseUrl}/sitemap.xml`;
        const searchEngines = [
            `https://google.com/ping?sitemap=${sitemapUrl}`,
            `https://www.bing.com/webmaster/ping.aspx?sitemap=${sitemapUrl}`,
            `https://www.yandex.ru/webmaster/ping.xml?sitemap=${sitemapUrl}`
        ];

        const pingPromises = searchEngines.map(async (url) => {
            try {
                const response = await fetch(url);
                console.log(`Pinged ${url}: ${response.status}`);
                return response.ok;
            } catch (error) {
                console.error(`Failed to ping ${url}:`, error);
                return false;
            }
        });

        const results = await Promise.allSettled(pingPromises);
        return results;
    }

    async updateSitemap() {
        const sitemap = await this.generateSitemap();
        if (sitemap) {
            // Сохраняем sitemap (можно через API или в localStorage)
            console.log('Sitemap generated successfully');
            return sitemap;
        }
        return null;
    }
}

export default SitemapGenerator;
